import { Shark } from "shark-mvc";
import NousCoreModel from "./NousCoreModel";

class User extends NousCoreModel {
	email = "";
	enabled = true;
	extraData = {
		profilePicture: {
			thumbURL: "",
			url: "",
		},
	};
	firstName = "";
	lastLoginAt = "0000-00-00 00:00:00";
	lastName = "";
	password = "";
	phone = "";
	roles = [];
	tempKey = "";

	__fullName = "";
	__isBackupOperator = false;
	__matchSearch = true;
	__passwordCheck = "";
	__preserveLogin = true;
	__render = true;
	__searchInfo = "";
	__selected = false;

	constructor (data) {
		super();

		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = this.__export();//Dave: ma non sarebbe bello avere un metodo che prende lista di campi da includere e/o escludere?

		exportData.extraData = this.exportObjectField("extraData");

		if (this.password === "unchanged") {
			exportData.password = "";
		}

		return exportData;
	}

	hasRole (roles) {
		if (Array.isArray(roles)) {
			let found = false;

			for (let i = 0; i < roles.length; i++) {
				found = this.roles.includes(roles[i]);
	
				if (found) {
					break;
				}
			}

			return found;
		}
		else {
			return this.roles.indexOf(roles) > -1;
		}
	}

	import (data, options) {
		this.__import(data, options);

		if (this.importDateField("lastLoginAt", data.lastLoginAt)) {
			this.__lastLoginAtLabel = this.lastLoginAt.format("DD/MM/YYYY - HH:mm");
		}

		this.__fullName = this.firstName + " " + this.lastName;
		this.password = "";
		this.__passwordConfirm = "";

		this.__searchInfo = this.lastName + " " + this.firstName + " " + this.email + " " + this.phone;

		this.parseRoles();
	}

	isValid (mode) {
		this.validate(mode);
		return this.__isValid;
	}

	parseRoles () {
		this.roles.forEach(role => this[`__role_${role}`] = true);
	}

	validate (mode) {
		const errors = [];
		this.__errors = {};
		this.__isValid = true;

		const eMailRegExp = new RegExp(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

		//Questo va riscritto tutto
		if (mode !== "setNewPassword") {
			if (this.email.trim() === "" || !eMailRegExp.test(this.email.trim())) {
				this.__errors.email = true;
				this.__isValid = false;
			}

			if (mode === "register") {
				if (this.password.trim() === "") {
					this.__errors.password = true;
					this.__isValid = false;
				}
				if (this.password.trim() !== this.__passwordCheck.trim()) {
					this.__errors.__passwordCheck = true;
					this.__isValid = false;
				}
			}
			if (mode === "update") {
				if (this.password.trim() !== "" && this.password.trim() !== this.__passwordCheck.trim()) {
					this.__errors.__passwordCheck = true;
					this.__isValid = false;
				}
			}
			
			if (mode === "login") {
				if (this.password.trim() === "") {
					this.__errors.password = true;
					this.__isValid = false;
				}
			}
			else if (mode !== "requestPasswordRecovery") {
				if (this.firstName.trim() === "") {
					this.__errors.firstName = true;
					this.__isValid = false;
				}

				if (this.lastName.trim() === "") {
					this.__errors.lastName = true;
					this.__isValid = false;
				}

				// if (mode !== "register" && this.phone.trim() === "") {
				// 	this.__errors.phone = true;
				// 	this.__isValid = false;
				// }
			}
		}

		else {
			if (this.password.trim().length < 6) {
				errors.push("La password deve essere lunga almeno 6 caratteri.");
				this.__errors.password = true;
			}
			if (this.__passwordCheck.trim() === "" || this.password.trim() !== this.__passwordCheck.trim()) {
				errors.push("La password di verifica non corrisponde.");
				this.__errors.passwordConfirm = true;
			}
		}

		return errors;

	}
}

Shark.registerModel("User", User);

export default User;